import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Button, ButtonToolbar, HelpBlock } from 'react-bootstrap';

import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';
import { left, center, right, justify, Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

class NoteFormRich extends React.Component {
  constructor(props) {
    super(props);
    const editorState = EditorState.createEmpty();

    this.state = {
      editorState,
      pristine: true,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  onEditorStateChange: Function = editorState => {
    this.setState({
      editorState,
      pristine: false,
    });
  };
  handleSubmit() {
    this.props.onSubmit(convertToRaw(this.state.editorState.getCurrentContent()));
  }
  render() {
    const { editorState, pristine } = this.state;
    return (
      <div className="row">
        <div className="col-md-12 hotel-details-description">
          <Editor
            editorState={editorState}
            toolbarClassName="toolbarClassName"
            wrapperClassName="wrapperClassName"
            editorClassName="editorClassName"
            toolbar={{
              options: ['inline', 'blockType', 'list', 'textAlign', 'history'],
              inline: {
                options: ['bold', 'italic', 'underline'],
              },
              blockType: {
                options: ['Normal', 'H1', 'H2'],
                className: 'fontSizeDrop',
              },
              textAlign: {
                options: ['left', 'center', 'right'],
              },
            }}
            onEditorStateChange={this.onEditorStateChange}
          />
          <FormGroup><br/>
            <ButtonToolbar>
              <Button disabled={pristine} bsStyle="success" onClick={this.handleSubmit}>
                Add Note
              </Button>
              <Button bsStyle="danger" onClick={this.props.handleClose}>
                Cancel
              </Button>
            </ButtonToolbar>
          </FormGroup>
        </div>
      </div>
    );
  }
}
NoteFormRich.propTypes = {
  handleClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default NoteFormRich;



// WEBPACK FOOTER //
// src/routes/tours/components/NoteFormRich.js